import { ReadSyncValidationsDocument } from 'generated/resources/graphql'
import { print } from 'graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useLazyQuery } from 'modules/core/hooks/useQuery'

import { usePrivateIntegrationsSyncContext } from 'modules/integrations/hooks/SyncContext'
import { toSyncParameters } from 'modules/integrations/lib/parameters'
import {
  BlockingIssue,
  useCompensationsBlockingIssues,
} from 'modules/integrations/hooks/SyncContext/blockingIssues'

interface UseBlockingIssuesLazyQueryResult {
  fetchBlockingIssues: () => Promise<void>
  blockingIssues: BlockingIssue[]
  blockingIssuesLoading: boolean
}

export const useBlockingIssuesLazyQuery = (): UseBlockingIssuesLazyQueryResult => {
  const {
    syncEnabled,
    marketplaceIntegration,
    contextParameters,
    getDataCollectionSource,
    configuration,
  } = usePrivateIntegrationsSyncContext()

  const {
    company: { id: companyId },
  } = useCurrentSession()
  const [
    fetchSyncValidationsQuery,
    { data: blockingIssuesData, loading: blockingIssuesLoading, networkActivity },
  ] = useLazyQuery(ReadSyncValidationsDocument)

  const blockingIssues =
    blockingIssuesData?.integrations?.syncValidationsConnection.nodes[0]?.blockingIssues || []

  const fetchBlockingIssues = async () => {
    if (!syncEnabled || !marketplaceIntegration) return

    const dataCollectionSource = getDataCollectionSource()

    const mappedVariables = dataCollectionSource?.mappedVariables
    const queryForSync = dataCollectionSource?.document
      ? print(dataCollectionSource.document)
      : null

    await fetchSyncValidationsQuery({
      variables: {
        companyId,
        marketplaceIntegrationId: marketplaceIntegration.id,
        origin: configuration.origin,
        parameters: toSyncParameters(contextParameters),
        graphqlVariablesJson: queryForSync
          ? JSON.stringify({
              query: queryForSync,
              variables: { ...mappedVariables },
            })
          : undefined,
      },
    })
  }

  return {
    fetchBlockingIssues,
    blockingIssues: useCompensationsBlockingIssues(blockingIssues, marketplaceIntegration),
    blockingIssuesLoading: networkActivity || blockingIssuesLoading,
  }
}
